import Handlebars from 'handlebars';
import { fetchJson } from '../core/ajax-json.js';

// Create config object for navigation and title
function setButtonConfig(buttons) {
	const SHOW = 'u-show';
	const HIDE = 'u-hide';
	const buttonConfig = {
		close: HIDE,
		back: HIDE,
		next: HIDE,
	};
	if (buttons && buttons.forEach) {
		buttons.forEach(button => {
			if (!buttonConfig.hasOwnProperty(button)) {
				throw new Error(`No matching button for specified button config "${button}"`);
			}
			buttonConfig[button] = SHOW;
		});
	}
	return buttonConfig;
}

/*
 * Todo: Move html to mustache file
 */
function renderFlowView(fetchResult, title, buttons, context) {
	Handlebars.registerHelper('flow-content', (contentContext) => {
		const contextPath = Handlebars.escapeExpression(contentContext.path);

		return new Handlebars.SafeString(
			`<div class="u-height-100" id="${contextPath}-content">${contentContext.content}</div>`
		);
	});
	const flowViewTemplate = Handlebars.compile(fetchResult.templates['flow-view']);
	const rootContext = fetchResult.rootContext || {};
	rootContext.context = context;
	rootContext.title = title;
	rootContext.buttons = buttons;
	return flowViewTemplate(rootContext);
}

function childSpinnerOnAction(parentNode) {
	if (parentNode && parentNode.querySelector) {
		return (spinnerOn(parentNode.querySelector('.spinner')));
	}
	return undefined;
}
function siblingSpinnerOnAction(spinnerSibling) {
	if (spinnerSibling && spinnerSibling.parentNode) {
		return childSpinnerOnAction(spinnerSibling.parentNode);
	}
	return undefined;
}
function spinnerOn(spinnerElement) {
	if (spinnerElement && spinnerElement.classList) {
		spinnerElement.classList.remove('u-hide');
		return spinnerElement;
	}
	return undefined;
}
function spinnerOff(spinnerElement) {
	if (spinnerElement && spinnerElement.classList) {
		spinnerElement.classList.add('u-hide');
	}
}

function flowView(title, buttons, context) {
	const url = '/template/flow-view';

	return fetchJson(url)
		.then((restResult) => {
			if (restResult.status === 'SUCCESS') {
				return renderFlowView(restResult.result, title, buttons, context);
			}

			throw new Error(`Rest result status: ${restResult.status}`);
		});
}

export {
	setButtonConfig,
	flowView,
	childSpinnerOnAction,
	siblingSpinnerOnAction,
	spinnerOff,
	spinnerOn,
};



// WEBPACK FOOTER //
// ./mobile-core/src/flow/flow-view.js